import { ITransportationGoodsInsurable } from '@webapp/risks';
import { IBasePolicy, PolicyTabNames } from '../../interfaces/policies.interface';
import { InsurableMapper } from '../insurableMapper';

export class TransportationGoodsInsurableMapper implements InsurableMapper<ITransportationGoodsInsurable> {
  map(insurable: unknown): ITransportationGoodsInsurable {
    return insurable as ITransportationGoodsInsurable;
  }

  getTitle(policy: IBasePolicy, insurable: ITransportationGoodsInsurable): string {
    return `#${policy.internalNumber} - ${insurable?.description || policy.title || ''}`;
  }

  getTabs(): string[] {
    return [PolicyTabNames.INFO, PolicyTabNames.INSURED];
  }
}
